export default {
      id: "truckSatellite-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons.svg#truckSatellite",
      toString: function () {
        return this.url;
      }
    }